import {ApiUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorsExportModal} from 'entities/monitor';

import {buildDomainMonitorsExportRequest} from './domainMonitorsExportRequest';
import DomainMonitorFiltersForm from '../DomainMonitorsFilters/DomainMonitorFiltersForm/DomainMonitorFiltersForm';

interface IDomainMonitorsExportModalProps {
    open: boolean,
    handleClose: () => void,
}

const DomainMonitorsExportModal: React.FC<IDomainMonitorsExportModalProps> = ({open, handleClose}) => (
    <MonitorsExportModal
        open={open}
        handleClose={handleClose}
        header={t`Экспорт мониторов доменов`}
        path={ApiUrls.DOMAIN_MONITORS_EXPORT}
        FiltersForm={DomainMonitorFiltersForm}
        buildRequest={buildDomainMonitorsExportRequest}
        countLabel={t`Экспортировано мониторов доменов`}
    />
);

export default DomainMonitorsExportModal;
